/**
 * Add a fillerElement on the last row of the chunked array to ensure each row has the same length
 * @param {Array} chunkedArray Chunked array to fill
 * @param {Number} chunksSize Size of chunks
 * @param {Object} fillerElement Object to add in the last row
 * @return {Array} Chunked array with each line of the same length if fillerElement is defined
 */
const completeLastRowWithFillerElement = (chunkedArray, chunksSize, fillerElement) =>
    fillerElement ?
        chunkedArray.map(
            (row, index) =>
                index === chunkedArray.length - 1 ?
                    [
                        ...row,
                        ...Array(chunksSize).fill(fillerElement)
                    ].slice(0, chunksSize)
                    : row
        )
        : chunkedArray;


/**
 * Chunk the given array
 * @param {Array} array Array to chunk
 * @param {Number} chunksSize Size of chunks
 * @param {Object} fillerElement Object to add in the last row
 * @return {Array} Chunked array
 */
export default (array, chunksSize, fillerElement) =>
    completeLastRowWithFillerElement(
        array.reduce(
            (acc, element, index) => {
                // Add on the int(index / chunksSize)'th row the current element
                const rowNumber = Math.floor(index / chunksSize);
                acc[rowNumber] = [...(acc[rowNumber] || []), element];
                return acc;
            },
            []
        ),
        chunksSize,
        fillerElement
    );